module.exports = __webpack_public_path__ + "static/media/up.d8fafbac.svg";